<template>
	<div class="video-container">
		<div class="post__body__placeholder flex" v-if="!loaded">
			<Spinner :size="60" :color="'#3897f0'"></Spinner>
		</div>
		<div class="video-overlay" @click="showModal(postNumber, number)"></div>
		<transition name="fade-button">
			<video
				v-show="loaded"
				:src="videoUrl"
				@canplay="loadedVideo"
				controls
				playsinline
				preload="auto"
				class="post-video"
			></video>
		</transition>
	</div>
</template>

<script>
import loadProtectedVideo from "@/utils/loadProtectedVideo";
import { mapState } from "vuex";

export default {
	props: {
		path: {
			type: String,
			required: true,
		},
		number: {
			type: Number,
			required: true,
		},
		postNumber: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			observer: null,
			intersected: false,
			loaded: false,
			blobUrl: "",
		};
	},
	computed: {
		...mapState(["token"]),
		videoUrl() {
			return this.blobUrl;
		},
	},
	watch: {
		async intersected(isIntersected) {
			if (isIntersected && this.path && this.token) {
				this.blobUrl = await loadProtectedVideo(this.path, this.token);
			}
		},
	},
	mounted() {
		this.observer = new IntersectionObserver((entries) => {
			const video = entries[0];

			if (video.isIntersecting) {
				this.intersected = true;
			}
		});

		this.observer.observe(this.$el);
	},
	destroyed() {
		this.observer.disconnect();
		// Clean up blob URL to prevent memory leak
		if (this.blobUrl) {
			URL.revokeObjectURL(this.blobUrl);
		}
	},
	methods: {
		loadedVideo() {
			this.loaded = true;
		},
		showModal(index1, index2) {
			const postIndexes = [];
			postIndexes.push(index1);
			postIndexes.push(index2);
			this.$store.dispatch("getImageModalSrc", postIndexes);
		},
	},
};
</script>

<style scoped>
.video-container {
	width: 100%;
	position: relative;
}

.video-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10;
	cursor: pointer;
}

.post-video {
	width: 100%;
	max-width: 100%;
	cursor: pointer;
	border-radius: 4px;
}
</style>
